import React from 'react';

import { Card } from './styles';

interface Props {
  icon: string;
  name: string;
  address: string;
  onSelect: () => void;
}

const CardItem = ({ icon, name, address, onSelect }: Props) => (
  <Card onClick={onSelect}>
    <Card.Icon src={`/images/billing/search-${icon}.svg`} alt="" />
    <Card.Detail>
      <Card.Name>{name.replaceAll('undefined', '')}</Card.Name>
      <Card.Address>{address.replaceAll('undefined', '')}</Card.Address>
    </Card.Detail>
    <Card.ArrowIcon />
  </Card>
);

export default CardItem;
